export default {
  response: [],
  items: [],
  pagination: {},
  error: {},
  size: 20,
  afterSelected: null,
};
